<template lang="pug">
  b-modal#dailySettlement(
    ref="dailySettlement"
    :title="$t('ui.transfer_history')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="xl"
    @ok="done"
    @show="reset"
    @shown="shown"
    hide-footer
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountID.toUpperCase() }}]
      b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="dailySettlement" :fields="fields" :per-page="perPage" :filter="filter")
        template(v-slot:cell(index)="row")
          span {{ row.index + 1 }}
        template(v-slot:cell(transaction_date)="row")
          span {{ $moment(row.item.transaction_date).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-slot:cell(account_id)="row")
          span {{ row.item.account_id.toUpperCase() }}
        template(v-slot:cell(settled_amount)="row")
          span(:class="$helpers.getNumberClass(row.item.settled_amount)") #[b {{ row.item.settled_amount | currency }} ]
        template(v-slot:cell(account_before_balance)="row")
          span(:class="$helpers.getNumberClass(row.item.account_before_balance)") #[b {{ row.item.account_before_balance | currency }} ]
        template(v-slot:cell(account_after_balance)="row")
          span(:class="$helpers.getNumberClass(row.item.account_after_balance)") #[b {{ row.item.account_after_balance | currency }} ]
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
</template>

<script>
import config from "@/config";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect,
    SubmitButton
  },
  props: {
    accountID: "",
    date: ""
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      dailySettlement: [],
      filter: null,
      sortBy: "working_date",
      sortDesc: false
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "transaction_date",
          label: this.$t("ui.transaction_date"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "transfer_method",
          label: this.$t("ui.transfer_method"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "remark",
          label: this.$t("ui.remark"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
        },
        {
          key: "settled_amount",
          label: this.$t("ui.amount"),
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "account_before_balance",
          label: this.$t("ui.account_before_balance"),
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "account_after_balance",
          label: this.$t("ui.account_after_balance"),
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.dailySettlement = []
      let account_id = this.accountID
      let working_date = this.$moment(this.date).format("YYYY-MM-DD")
      this.loading = true
      this.$store
        .dispatch("user/getDailySettlement", { account_id, working_date })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.dailySettlement = response.data
            }
          } else {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.loading = false
          if((typeof response.errorTag) != 'object') {
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          }
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
    },
    shown: function() {
      this.submit()
    },
    cancel: function() {
      this.$refs.dailySettlement.hide()
    }
  }
};
</script>

